import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * 获取当前美东时间对应的税务年份
 *
 * 规则：
 * - 如果美东时间 < 当年4月15日，则属于前一年
 * - 否则属于当前年
 */
export function getCurrentTaxYear() {
    const nowEastern = dayjs().tz('America/New_York');
    const april15 = dayjs.tz(`${nowEastern.year()}-04-15 00:00:00`, 'America/New_York');

    return nowEastern.isBefore(april15) ? nowEastern.year() - 1 : nowEastern.year();
}
